var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-search-box",
        { on: { enter: _vm.getList } },
        [
          _c("template", { slot: "search" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-select", {
                  attrs: {
                    codeGroupCd: "RAM_RISK_HAZARD_CLASS_CD",
                    type: "search",
                    itemText: "codeName",
                    itemValue: "code",
                    name: "ramRiskHazardClassCd",
                    label: "LBLCLASSIFICATION",
                  },
                  model: {
                    value: _vm.searchParam.ramRiskHazardClassCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "ramRiskHazardClassCd", $$v)
                    },
                    expression: "searchParam.ramRiskHazardClassCd",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c(
        "c-table",
        {
          ref: "table",
          attrs: {
            title: "LBL0001154",
            tableId: "riskHazrd01",
            columns: _vm.grid.columns,
            data: _vm.grid.data,
            gridHeight: _vm.grid.height,
            filtering: false,
            columnSetting: false,
            usePaging: false,
            selection: _vm.popupParam.type,
            rowKey: "ramRiskHazardId",
          },
        },
        [
          _c(
            "template",
            { slot: "table-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _c("c-btn", {
                    attrs: { label: "LBLSEARCH", icon: "search" },
                    on: { btnClicked: _vm.getList },
                  }),
                  _vm.editable
                    ? _c("c-btn", {
                        attrs: { label: "LBLSELECT", icon: "add" },
                        on: { btnClicked: _vm.select },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }